import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import images from '../assets/images';
import './App.scss';
import Item from './Item';

export interface IProject {
  title: string;
  sceenshotList: Array<string> | null;
  mobileSceenshotList?: Array<string> | null;
  isWebProject?: boolean;
  descTitle: string;
  descList: Array<string>;
  playStoreUrl: string | null;
  appStoreUrl: string | null;
  webUrl?: string | Array<string> | null;
}

const PROJECT_LIST: Array<IProject> = [
  {
    title: 'INTRODUCTION',
    sceenshotList: null,
    descTitle:
      'UI/UX 기획부터 시스템 아키텍처 설계, 모바일/웹 런칭, 그리고 프로덕트 운영까지 Product Life-cycle 전반에 대한 깊은 이해도를 갖춘 풀스택(Full-stack) 지향 시니어 개발자입니다.',
    descList: [
      '[기술스택]',
      '',
      '- Android, iOS 네이티브 App 개발',
      '- React-Native App 개발',
      '- Flutter App 개발',
      '- JS, JQeury 기반 WebApp 개발',
      '- React.js 웹 프론트엔드 개발',
      '- Next.js 웹 프론트엔드 개발 / SEO, GEO',
      '- Node.js 백엔드 개발',
      '',
      '[업종분야]',
      '',
      '- 핀테크(삼성페이)',
      '- 자동차(맵기반 모빌리티 플랫폼)',
      '- 소셜 네트워킹(WebRTC, WebSocket 기반 음성/영상 통화구현)',
      '- 의료(비대면 진료: 영상통화)',
      '- 건축공사 현장관리(삼성엔지니어링)',
      '- 중장비, 건설기계(두산 인프라코어)',
      '- 대형 온라인 쇼핑몰(현대 Hmall)',
      '- 통신사 렌탈 플랫폼 (B2B, B2C)',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'PROFILE',
    sceenshotList: null,
    descTitle: '학력, 스킬, 수상 및 외국어 정보',
    descList: [
      '[학력]',
      '',
      '- 한양대학교 컴퓨터공학과 학사 (2003.03 - 2010.02)',
      '',
      '[스킬]',
      '',
      '- React Native, Android, iOS, Java, Kotlin, Swift, ObjectiveC, JavaScript',
      '- Zeplin, Figma, Adobe XD',
      '- Git, Github',
      '- React.js, Next.js',
      '',
      '[수상 및 기타]',
      '',
      '- 정보처리기사 (국가기술자격증) / 2009.11',
      '- 삼성 SW 알고리즘 Professional Level 취득 (삼성 SDS 교육사업부) / 2017.06',
      '',
      '[외국어]',
      '',
      '- 영어 (비즈니스회화)',
      '- OPIC IM2 (2018.06.17)',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'WORK EXPERIENCE',
    sceenshotList: null,
    descTitle: '실무 프로젝트 경력',
    descList: [
      '회사 소속, 외주개발 및 프리랜서 등 실무 프로젝트 경력 목록입니다.'
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'RNPL(렌플) - 렌탈 플랫폼',
    isWebProject: true,
    sceenshotList: [
      images.annex_landing_page_client_01,
      images.annex_landing_page_client_02,
      images.annex_platform_admin_client_01,
      images.annex_platform_admin_client_02,
      images.annex_rental_platform_client_01,
      images.annex_rental_platform_client_02,
      images.annex_consumer_page_client_01,
      images.annex_consumer_page_client_02,
    ],
    descTitle: 'Annex Telecom 렌탈 플랫폼 구축 프로젝트',
    descList: [
      '2023.06 - 2026.06',
      '',
      'React.js 기반 통합 관리 플랫폼 및 Next.js 기반 B2B/B2C 랜딩 서비스 프론트엔드 구축',
      '- B2B 파트너 센터/랜딩 페이지 구축',
      '- B2C 고객 모바일 웹 사이트 구축',
      '- 통합 관리자 어드민 페이지 구축',
      '',
      'Node.js 백엔드 서버 구축',
      '- Node.js 기반 비동기 계약서 자동 생성 파이프라인 및 고객 전자 서명 API 연동',
      '- 계약서 다운로드 API 구축',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
    webUrl: [
      'https://rnpl.co.kr/',
      'https://app.rnpl.co.kr/',
      'https://pladm.rnpl.co.kr/',
      'https://cs.rnpl.co.kr',
    ],
  },
  {
    title: '현대 Hmall 차세대 프로젝트',
    isWebProject: true,
    sceenshotList: [
      images.hmall_01,
      images.hmall_02,
      images.hmall_03,
      images.hmall_04,
      images.hmall_05,
      images.hmall_06,
      images.hmall_07,
    ],
    mobileSceenshotList: [
      images.hmall_m_01,
      images.hmall_m_02,
      images.hmall_m_03,
      images.hmall_m_04,
      images.hmall_m_05,
      images.hmall_m_06,
      images.hmall_m_07,
    ],
    descTitle: '현대 Hmall 차세대 프로젝트',
    descList: [
      '2023.1 - 2023.6월',
      '',
      'Next.js 기반 현대 Hmall PC / Mobile 용 쇼핑몰 Web 차세대 프로젝트 개발',
      '- 이벤트 템플릿 페이지 구현',
      '- 전시 상품 / 상세 화면 구현',
      '- Next.js를 활용한 SSR/CSR 렌더링 분리 및 SEO 성능 최적화',
      '- TypeScript 환경의 견고한 타입 시스템 확립 및 SWR을 이용한 데이터 패칭(Fetching) 최적화',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
    webUrl: 'https://www.hmall.com',
  },
  {
    title: '어디아파 - 비대면 진료 서비스',
    sceenshotList: [
      images.whatailsyou_01,
      images.whatailsyou_02,
      images.whatailsyou_03,
      images.whatailsyou_04,
      images.whatailsyou_05,
      images.whatailsyou_06,
      images.whatailsyou_07,
      images.whatailsyou_08,
    ],
    descTitle: 'React-native Project (비플러스랩)',
    descList: [
      '2022.02 - 2022.12',
      '',
      '- 블록체인 기반 본인인증 시스템 구축',
      '- FCM(Push Service) 연동 모듈 구현',
      '- 스마트 건강 문진 모듈 개발',
      '- 실시간 영상 비대면 진료(WebRTC, WebSocket)',
      '- CS 및 약배송 시스템 구축',
      '- 모바일 개발 PL',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.whatailsyou.app',
    appStoreUrl:
      'https://apps.apple.com/kr/app/id1436802419',
  },
  {
    title: 'ITMS - 시험 성적서 관리 시스템 (Web & Tablet)',
    isWebProject: true,
    sceenshotList: [
      images.itms_web_01,
      images.itms_web_02,
      images.itms_web_03,
      images.itms_web_04,
      images.itms_web_05,
      images.itms_web_06,
      images.itms_web_07,
      images.itms_web_08,
      images.itms_web_09,
      images.itms_web_10,
      images.itms_web_11,
    ],
    mobileSceenshotList: [
      images.itms_app_01,
      images.itms_app_02,
      images.itms_app_03,
      images.itms_app_04,
      images.itms_app_05,
      images.itms_app_06,
      images.itms_app_07,
      images.itms_app_08,
    ],
    descTitle: 'React.js & React-native Project (Hyundai Mobis)',
    descList: [
      '2021.09 - 2022.01',
      '',
      '[Web - React.js]',
      '- 성적서 템플릿 생성 및 편집 Engine 개발',
      '- 성적서 템플릿 Rendering Engine 개발',
      '- PDF 출력, 다운로드 구현',
      '',
      '[Tablet - React Native]',
      '- Tablet 플렉서블 UI 적용',
      '- 성적서 템플릿 모바일 Rendering Engine 개발',
      '- OCR 장비 인식 기능 구현',
      '- Google Play Store, Apple AppStore 미출시(In-house 배포)',
      '',
      '- Front-end 개발 PL',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'KIND - 프리미엄 소개팅',
    sceenshotList: [
      images.kind_01,
      images.kind_02,
      images.kind_03,
      images.kind_04,
      images.kind_05,
    ],
    descTitle: 'React-native Project (Three comma club)',
    descList: [
      '2021.04 - 2021.08',
      '',
      '- 회원가입 / 로그인 / 소셜 로그인',
      '- GA(Google Analytics) 연동',
      '- Pass 본인인증 인증 구축',
      '- WebRTC, WebSocket 이용 음성통화 / 영상통화 구축',
      '- 실시간 채팅 기능 구현',
      '- FCM(Push Service) 연동 모듈 구현',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kind',
    appStoreUrl:
      'https://apps.apple.com/ca/app/id1485826140',
  },
  {
    title: 'ENGINE PARTS BOOK',
    sceenshotList: [
      images.engine_01,
      images.engine_02,
      images.engine_03,
      images.engine_04,
      images.engine_05,
    ],
    descTitle: 'React-native Project (Doosan Infracore)',
    descList: [
      '2020.11 - 2021.03',
      '',
      '- 로그인, 회원가입 Legacy 시스템 연동 구축',
      '- 파츠북 PDF 분산 다운로드 구현',
      '- PDF 태그 인식 모듈 구현',
      '- Android, iOS 앱 스토어배포',
      '- 모바일, Back-end 개발 PL',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.doosaninfracore.enginepartsbook.rn',
    appStoreUrl: 'https://apps.apple.com/kr/app/engine-parts-book/id1550211920',
  },
  {
    title: 'Mocean - 법인카셰어링',
    sceenshotList: [
      images.mocean_01,
      images.mocean_02,
      images.mocean_03,
      images.mocean_04,
      images.mocean_05,
      images.mocean_06,
      images.mocean_07,
      images.mocean_08,
      images.mocean_09,
      images.mocean_10,
      images.mocean_11,
    ],
    descTitle: 'React-native Project (Hyundai Motor Group)',
    descList: [
      '2019.03 - 2020.10',
      '',
      '- Kakao Map 라이브러리 커스터마이징',
      '- 회원가입 로그인 (Legacy 시스템 연동) 구축, SSO 연동',
      '- 차량 예약 및 예약 내역 조회 구축',
      '- 신용카드, 운전면허증 인식 구현',
      '- BLE(Bluetooth) 연동 스마트키 차량 제어 기술 구현(차량 찾기, 도어 열림/닫힘, 시동 on/off)',
      '- Android, iOS 다국어 적용',
      '- 모바일 개발 PL',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.mocean.userapp',
    appStoreUrl:
      'https://apps.apple.com/kr/app/id1497479540',
  },
  {
    title: '산업환경 현장 모바일',
    sceenshotList: null,
    descTitle: 'Android Project (Samsung Engineering)',
    descList: [
      '2018.01 - 2019.02',
      '',
      '- 산업환경 현장 모바일 (WebApp) Android 앱 개발 / 운영 (JavaScript)',
      '- 삼성엔지니어링 공사 현장 관리를 위한 웹 애플리케이션 구축 및 운영',
      '- Android 앱 유지 및 보수',
      '',
      '- In-House 배포',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성페이 Android',
    sceenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2017.01 - 2017.12',
      '',
      '- 삼성페이 Android 네이티브 앱 개발 / 운영 (Java)',
      '- 삼페숏핑 리뉴얼 개발 (React-Native)',
      '- Android 기 출시 앱 유지 및 보수',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성페이 iOS',
    sceenshotList: null,
    descTitle: 'iOS Project (Samsung Electronics)',
    descList: [
      '2015.07 - 2016.12',
      '',
      '- 삼성페이 iOS 네이티브 앱 개발 (Swift)',
      '- 회원가입 / 로그인 구현',
      '- PG사 연동 신용카드 등록 / 삭제 / 추가 기능 구현',
      '- 멤버십 카드 관리 기능 구현',
      '- iOS 미출시',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성월렛',
    sceenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2014.12 - 2015.06',
      '',
      '- 삼성월렛 Android 네이티브 앱 개발 / 운영 (Java)',
      '- CLO 멤버십 연동 기능 구현',
      '- 스탬프 인식 라이브러리 연동 및 개발',
      '- Android 기 출시 앱 유지보수 및 배포작업',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: '삼성북스',
    sceenshotList: null,
    descTitle: 'Android Project (Samsung Electronics)',
    descList: [
      '2010.02 - 2014.11',
      '',
      '- 삼성북스 Android 네이티브 앱 개발 / 운영 (Java)',
      '- 북스토어 메인 화면 개발, 결제 시스템 연동 구축',
      '- Android 앱 유지 / 보수, 업데이트 배포',
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'PERSONAL PROJECTS',
    sceenshotList: null,
    descTitle: '개인 사이드 프로젝트',
    descList: [
      '개인 아이디어로 기획부터 디자인, 개발, 상용 배포까지 직접 진행한 자체 서비스 목록입니다.'
    ],
    playStoreUrl: null,
    appStoreUrl: null,
  },
  {
    title: 'FREEDIVE - Ai Trainer',
    sceenshotList: [
      images.freedive_01,
      images.freedive_02,
      images.freedive_03,
      images.freedive_04,
      images.freedive_05,
      images.freedive_06,
      images.freedive_07,
      images.freedive_08,
    ],
    descTitle: '프리다이빙 스포츠 트레이닝 서비스 (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- React-native Project',
      '- Firebase Cloud 서비스 활용: Authentication, Firestore, Storage, Hosting, Remote Config, Messaging',
      '- 백그라운드 타이머 서비스 구현',
      '- Audio Streaming 서비스 구현',
      '- 프리다이빙 장비 BLE(Bluetooth) 기기 연동 개발',
      '- 한국, 미국, 일본, 중국 등 13개국 다국어 적용',
      '- Fastlane 자동화 배포 시스템 구축'
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.freedive',
    appStoreUrl:
      'https://apps.apple.com/kr/app/freedive-training-learn/id1567940653',
  },
  {
    title: 'App Revenue Console',
    sceenshotList: [
      images.app_revenue_console_01,
      images.app_revenue_console_02,
      images.app_revenue_console_03,
      images.app_revenue_console_04,
      images.app_revenue_console_05,
      images.app_revenue_console_06,
      images.app_revenue_console_07,
    ],
    descTitle: '앱 수익 및 통계 분석 통합 대시보드 (개인 프로젝트)',
    descList: [
      'React Native(App) 및 React.js(Web) 기반 크로스 플랫폼 대시보드 구축',
      '- Google Play Store 및 Apple App Store 인앱결제(IAP) 수익 통합 연동',
      '- Google AdMob 광고 수익 데이터 연동 및 시각화',
      '- 유저 통계, 리텐션 등 주요 분석 지표 대시보드 구현',
      '- 모바일/웹 반응형 콘솔 UI/UX 설계 및 프론트엔드 개발',
      '- GCP(Google Cloud Platform) 기반 백엔드 서비스 연동',
      '- 한국, 미국, 일본 등 13개국 글로벌 다국어 적용',
      '- Fastlane을 활용한 자동 배포 파이프라인 구축',
    ],
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.giftsets.admobconsole',
    appStoreUrl: 'https://apps.apple.com/us/app/id6785726482',
    webUrl: 'https://admobconsole.web.app/',
  },
  {
    title: 'Salesman MAP',
    sceenshotList: [
      images.youngmap_01,
      images.youngmap_02,
      images.youngmap_03,
      images.youngmap_04,
      images.youngmap_05,
      images.youngmap_06,
      images.youngmap_07,
      images.youngmap_08,
    ],
    descTitle: '지도기반 CRM(고객관계관리) 솔루션 (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- React-native Project',
      '- Google Map / Clustering 구현',
      '- 인앱결제(IAP) 구독 시스템 연동 및 결제 영수증 검증(Receipt Validation) 비즈니스 로직 구축',
      '- 사용자 백오피스 구축 (http://www.youngmap.net)',
      '- 엑셀 업로드 / 다운로드, 데이터 연동 서비스 구축',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.youngmap',
    appStoreUrl:
      'https://apps.apple.com/kr/app/id1501942253',
  },
  {
    title: '나를 지켜주는 부적',
    sceenshotList: [
      images.amulet_01,
      images.amulet_02,
      images.amulet_03,
      images.amulet_04,
      images.amulet_05,
      images.amulet_06,
      images.amulet_07,
      images.amulet_08,
    ],
    descTitle: 'AI 운세 및 부적 생성 서비스 (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- React-native Project',
      '- Generative AI (LLM) 기반 맞춤형 운세 및 부적 컨텐츠 자동 생성 로직 구현',
      '- 인앱결제(IAP) 시스템 연동 및 수익화 구축',
      '- GCP 서비스 연동: Authentication, Firestore, Messaging',
      '- 안드로이드 / ios 네이티브 위젯 구축',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.amulet.third',
    appStoreUrl:
      'https://apps.apple.com/kr/app/id1474239446',
  },
  {
    title: 'PUPPY DOG WALLPAPERS',
    sceenshotList: [
      images.random_dog_01,
      images.random_dog_02,
      images.random_dog_03,
      images.random_dog_04,
    ],
    descTitle: '강아지 사진 / 일러스트 Wallpaper 서비스 (개인 프로젝트)',
    descList: [
      '- 기획, 디자인, 설계, 개발, 배포, 운영',
      '- React-native Project',
      '- 이미지 프로세싱(필터) 구현, 다운로드 구현',
      '- Pixabay API 활용',
    ],
    playStoreUrl:
      'https://play.google.com/store/apps/details?id=com.giftsets.randomdog',
    appStoreUrl:
      'https://apps.apple.com/kr/app/id1558962268',
  },
];

const App: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isResumeDownloading, setIsResumeDownloading] = useState(false);
  const [isDownloadMenuOpen, setIsDownloadMenuOpen] = useState(false);

  const downloadResume = async () => {
    setIsResumeDownloading(true);
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      let currentY = 0;
      
      const elementsToCapture = ['resume-header'];
      for (let i = 0; i < PROJECT_LIST.length; i++) {
        elementsToCapture.push(`resume-section-${i}`);
      }
      elementsToCapture.push('resume-footer');
      
      for (const id of elementsToCapture) {
        const element = document.getElementById(id);
        if (!element) continue;
        
        const canvas = await html2canvas(element, { 
          scale: 2, 
          useCORS: true, 
          backgroundColor: '#ffffff' 
        });
        
        const imgData = canvas.toDataURL('image/jpeg', 0.8);
        const ratio = pdfWidth / canvas.width;
        const w = canvas.width * ratio;
        const h = canvas.height * ratio;
        
        const topMargin = 15;
        const bottomMargin = 15;
        
        if (currentY + h > pdfHeight - bottomMargin && currentY > 0) {
          pdf.addPage();
          currentY = topMargin;
        }
        
        pdf.addImage(imgData, 'JPEG', 0, currentY, w, h);
        currentY += h;
      }
      
      pdf.save('resume.pdf');
    } catch (e) {
      console.error(e);
      alert('이력서 다운로드 중 오류가 발생했습니다.');
    } finally {
      setIsResumeDownloading(false);
    }
  };

  const downloadPDF = async () => {
    setIsDownloading(true);
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      const drawBackground = () => {
        pdf.setFillColor(40, 44, 52); // #282c34
        pdf.rect(0, 0, pdfWidth, pdfHeight, 'F');
      };
      
      const headerElement = document.querySelector('.App-header') as HTMLElement;
      if (headerElement) {
        drawBackground();
        const canvas = await html2canvas(headerElement, { 
          scale: 2, 
          useCORS: true, 
          backgroundColor: '#282c34' 
        });
        const imgData = canvas.toDataURL('image/jpeg', 0.8);
        const ratio = Math.min(pdfWidth / canvas.width, pdfHeight / canvas.height);
        const w = canvas.width * ratio;
        const h = canvas.height * ratio;
        const yPos = (pdfHeight > h) ? (pdfHeight - h) / 2 : 0;
        pdf.addImage(imgData, 'JPEG', (pdfWidth - w) / 2, yPos, w, h);
      }
      
      for (let i = 0; i < PROJECT_LIST.length; i++) {
        const itemElement = document.getElementById(`project-${i}`) as HTMLElement;
        if (itemElement) {
          pdf.addPage();
          drawBackground();
          const canvas = await html2canvas(itemElement, { 
            scale: 2, 
            useCORS: true, 
            backgroundColor: '#282c34' 
          });
          const imgData = canvas.toDataURL('image/jpeg', 0.8);
          const ratio = Math.min(pdfWidth / canvas.width, pdfHeight / canvas.height);
          const w = canvas.width * ratio;
          const h = canvas.height * ratio;
          const yPos = (pdfHeight > h) ? (pdfHeight - h) / 2 : 0;
          pdf.addImage(imgData, 'JPEG', (pdfWidth - w) / 2, yPos, w, h);
        }
      }
      
      pdf.save('portfolio.pdf');
    } catch (e) {
      console.error(e);
      alert('PDF 다운로드 중 오류가 발생했습니다.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className={'App'}>
      <div 
        className={'floating-btn-group'}
        style={{ position: 'fixed', bottom: '30px', right: '30px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '15px', zIndex: 999 }}
      >
        {isDownloadMenuOpen && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', backgroundColor: 'rgba(30, 30, 30, 0.85)', backdropFilter: 'blur(10px)', padding: '12px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)', boxShadow: '0 10px 25px rgba(0,0,0,0.5)', minWidth: '220px' }}>
            <div 
              style={{ padding: '12px 16px', cursor: 'pointer', borderRadius: '10px', fontWeight: 'bold', color: '#fff', display: 'flex', alignItems: 'center', gap: '12px', transition: 'all 0.2s ease' }}
              onClick={() => { setIsDownloadMenuOpen(false); downloadResume(); }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(97, 218, 251, 0.15)')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#61dafb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              경력 기술서 다운로드
            </div>
            <div 
              style={{ padding: '12px 16px', cursor: 'pointer', borderRadius: '10px', fontWeight: 'bold', color: '#fff', display: 'flex', alignItems: 'center', gap: '12px', transition: 'all 0.2s ease' }}
              onClick={() => { setIsDownloadMenuOpen(false); downloadPDF(); }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 71, 87, 0.15)')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff4757" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              포트폴리오 다운로드
            </div>
          </div>
        )}
        
        <div 
          className={'floating-action-btn'} 
          onClick={() => setIsDownloadMenuOpen(!isDownloadMenuOpen)} 
          title={'다운로드 메뉴'}
          style={{ pointerEvents: isDownloading || isResumeDownloading ? 'none' : 'auto', opacity: isDownloading || isResumeDownloading ? 0.7 : 1 }}
        >
          {isDownloading || isResumeDownloading ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1.5s linear infinite' }}>
              <line x1="12" y1="2" x2="12" y2="6"></line>
              <line x1="12" y1="18" x2="12" y2="22"></line>
              <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
              <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
              <line x1="2" y1="12" x2="6" y2="12"></line>
              <line x1="18" y1="12" x2="22" y2="12"></line>
              <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
              <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
          ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
          )}
        </div>
      </div>
      <div className={`App-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className={'sidebar-toggle'} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
          {isSidebarOpen ? '◀' : '▶'}
        </div>
        <div className={'sidebar-content'}>
          {PROJECT_LIST.map((item, index) => {
          const isMajorSection = item.title === 'INTRODUCTION' || item.title === 'PROFILE' || item.title === 'WORK EXPERIENCE' || item.title === 'PERSONAL PROJECTS';
          
          if (isMajorSection) {
            return (
              <div 
                key={index}
                className={'sidebar-major'}
                onClick={() => {
                  document.getElementById(`project-${index}`)?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {item.title}
              </div>
            );
          }

          return (
            <div
              key={index}
              className={'sidebar-item'}
              onClick={() => {
                document.getElementById(`project-${index}`)?.scrollIntoView({ behavior: 'smooth' });
              }}>
              {item.sceenshotList && item.sceenshotList[0] ? (
                <img
                  src={item.sceenshotList[0]}
                  alt={item.title}
                  className={'sidebar-thumbnail'}
                />
              ) : (
                <div className={'sidebar-thumbnail-placeholder'} />
              )}
              <p className={'sidebar-title'}>{item.title}</p>
            </div>
          );
        })}
        </div>
      </div>
      <div className={'App-content'}>
        <header className={'App-header'}>
          <div className={'title-container'}>
            <p className={'noselect'}>{'PORTFOLIOS'}</p>
          </div>
          <div className={'info-container'}>
            <p className={'info'}>{'HYEONGSEOK OH'}</p>
            <a className={'info-link'} href={'mailto:kevin85.oh@gmail.com'}>
              {'kevin85.oh@gmail.com'}
            </a>
          </div>
        </header>
        <main className={'App-main'}>
          {PROJECT_LIST.map((item, index) => {
            return (
              <div id={`project-${index}`} key={index}>
                <Item data={item} />
              </div>
            );
          })}
        </main>
      </div>

      <div 
        id="resume-container" 
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 0,
          width: '800px',
          backgroundColor: '#ffffff',
          color: '#000000',
          fontFamily: 'sans-serif'
        }}
      >
        <div id="resume-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '4px solid #000', padding: '50px 40px 20px 40px', backgroundColor: '#fff' }}>
          <h1 style={{ margin: 0, fontSize: '36px', color: '#000', fontWeight: '900' }}>경력 기술서</h1>
          <div style={{ textAlign: 'right' }}>
            <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0 0 5px 0', color: '#000' }}>오형석 (HYEONGSEOK OH)</p>
            <p style={{ fontSize: '16px', margin: 0, color: '#555' }}>kevin85.oh@gmail.com</p>
          </div>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {PROJECT_LIST.map((project, idx) => {
            const isMajorSection = project.title === 'INTRODUCTION' || project.title === 'PROFILE' || project.title === 'WORK EXPERIENCE' || project.title === 'PERSONAL PROJECTS';
            
            return (
              <React.Fragment key={idx}>
                <div id={`resume-section-${idx}`} style={{ 
                  paddingTop: isMajorSection && idx !== 0 ? '60px' : (isMajorSection ? '40px' : '0'), 
                  paddingBottom: isMajorSection ? '0' : '40px',
                  paddingLeft: '40px',
                  paddingRight: '40px',
                  backgroundColor: '#fff'
                }}>
                  <h2 style={{ 
                    fontSize: isMajorSection ? '24px' : '20px', 
                    borderBottom: isMajorSection ? '3px solid #000' : '2px solid #333', 
                    paddingBottom: '8px', 
                    marginBottom: '16px', 
                    color: '#111' 
                  }}>
                    {project.title}
                  </h2>
                  {project.descTitle && (
                    <p style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '10px', color: '#333' }}>
                      {project.descTitle}
                    </p>
                  )}
                  <ul style={{ paddingLeft: '20px', margin: 0 }}>
                    {project.descList.map((desc, dIdx) => {
                      if (desc === '') return <div key={dIdx} style={{ height: '8px' }} />;
                      const isBullet = desc.startsWith('-');
                      const text = isBullet ? desc.replace(/^-/, '').trim() : desc;
                      return (
                        <li 
                          key={dIdx} 
                          style={{ 
                            fontSize: '14px', 
                            lineHeight: '1.6',
                            listStyle: isBullet ? 'disc' : 'none', 
                            marginLeft: isBullet ? '0' : '-20px',
                            color: '#444'
                          }}
                        >
                          {text}
                        </li>
                      );
                    })}
                  </ul>

                  {/* 서비스 링크 표시 영역 */}
                  {(project.webUrl || project.playStoreUrl || project.appStoreUrl) && (
                    <div style={{ marginTop: '16px', padding: '12px 16px', backgroundColor: '#f8f9fa', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                      <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: 'bold', color: '#495057' }}>🌐 서비스 링크</p>
                      {project.webUrl && (
                        <p style={{ margin: '0 0 4px 0', fontSize: '13px', color: '#1c7ed6', wordBreak: 'break-all' }}>
                          <span style={{ color: '#868e96', fontWeight: 'bold', marginRight: '6px' }}>Web:</span>
                          {Array.isArray(project.webUrl) ? project.webUrl.join(', ') : project.webUrl}
                        </p>
                      )}
                      {project.playStoreUrl && (
                        <p style={{ margin: '0 0 4px 0', fontSize: '13px', color: '#1c7ed6', wordBreak: 'break-all' }}>
                          <span style={{ color: '#868e96', fontWeight: 'bold', marginRight: '6px' }}>Play Store:</span>
                          {project.playStoreUrl}
                        </p>
                      )}
                      {project.appStoreUrl && (
                        <p style={{ margin: '0', fontSize: '13px', color: '#1c7ed6', wordBreak: 'break-all' }}>
                          <span style={{ color: '#868e96', fontWeight: 'bold', marginRight: '6px' }}>App Store:</span>
                          {project.appStoreUrl}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </div>

        <div id="resume-footer" style={{ padding: '60px 40px 40px 40px', backgroundColor: '#fff' }}>
          <h2 style={{ fontSize: '24px', borderBottom: '3px solid #000', paddingBottom: '8px', marginBottom: '16px', color: '#111' }}>
            포트폴리오
          </h2>
          <ul style={{ paddingLeft: '20px', margin: 0 }}>
            <li style={{ fontSize: '14px', lineHeight: '1.6', listStyle: 'disc', color: '#444' }}>
              온라인 웹 포트폴리오 (상세 이미지 및 프로젝트 UI 제공)
            </li>
            <li style={{ fontSize: '14px', lineHeight: '1.6', listStyle: 'none', color: '#1c7ed6', marginLeft: '-20px', marginTop: '4px' }}>
              {'- https://giftsets.github.io'}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default App;
